import { Component } from 'preact';
import ploneApi from "api/PloneApi";

import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown } from 'reactstrap';

import { LinkHandlerContext } from 'components/Contexts';

export default class Navigation extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            navData: { items: [] }
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    componentDidMount() {
        ploneApi.fetch('@navigation?expand.navigation.depth=3')
            .then(data => {
                this.setState({
                    navData: data
                });
            })
    }

    handleClick(e, url, closeMenu = false) {
        e.preventDefault();
        this.openLink(url);
        closeMenu && this.setState({
            isOpen: false
        });
    }


    render() {
        const navItems = this.state.navData.items.map(item => {

            // filter index_pages that should not be displayed in the navigation
            if(item["@id"] === "index_page" || item["@id"] === "/index_page") {
                return {};
            }

            let children = item.items;

            // filter child index_pages that should not be displayed in the navigation
            if(item.items.length === 1) {
                children = (typeof children === "string") ? [] : children.filter(child => {
                    const childId = child["@id"].slice(item["@id"].length);
                    return !(childId === "index_page" || childId === "/index_page");
                });
            }

            if(children.length) {
                const children = item.items.map(child => {
                    return (
                        <DropdownItem onClick={(e => this.handleClick(e, child['@id'], true))}>
                            { child.title }
                        </DropdownItem>
                    );
                });
                return (
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            { item.title }
                        </DropdownToggle>
                        <DropdownMenu right>
                            { children }
                        </DropdownMenu>
                    </UncontrolledDropdown>
                );
            } else {
                return (
                    <NavItem>
                        <NavLink href={item['@id']}
                                 onClick={(e => this.handleClick(e, item['@id'], true))}>{item.title}</NavLink>
                    </NavItem>
                );
            }
        });

        return(
            <Navbar color="light" light expand="md">
                <LinkHandlerContext.Consumer>
                    { context => { this.openLink = context.openLink; return null; }}
                </LinkHandlerContext.Consumer>
                <NavbarBrand href="/" onClick={ (e => this.handleClick(e, "/")) }><img src={ ploneApi.publicPath + "/assets/logo.png" } alt="Landeskunde Digital" /></NavbarBrand>
                <NavbarToggler onClick={this.toggle}>
                    <span class="navbar-toggler-icon"></span>
                </NavbarToggler>
                <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav className="ml-auto" navbar>
                        { navItems }
                    </Nav>
                </Collapse>
            </Navbar>
        )
    }
}


// WEBPACK FOOTER //
// ./components/Navigations.jsx